import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import { LOGOUT_USER } from 'redux/actionTypes';
import activeUserId from './activeUserId';
import activeUserType from './activeUserType';
import authToken from './authToken';
import user from './user';
import customers from './customers';
import products from './products';
import categories from './categories';
import employees from './employees';
import vendors from './vendors';
import salesOrders from './salesOrders';
import purchaseOrders from './purchaseOrders';
import returnOrders from './returnOrders';
import expenses from './expenses';
import expenseTypes from './expenseTypes';
import newSalesOrder from './newSalesOrder';
import newPurchaseOrder from './newPurchaseOrder';
import idGen from './idGen';
import failedLogin from './failedLogin';

const appReducer = combineReducers({
    activeUserId,
    activeUserType,
    authToken,
    user,
    customers,
    products,
    categories,
    employees,
    vendors,
    salesOrders,
    purchaseOrders,
    returnOrders,
    expenses,
    expenseTypes,
    newSalesOrder,
    newPurchaseOrder,
    idGen,
    failedLogin
});

export const rootReducer = (state, action) => {
    if(action.type === LOGOUT_USER) {

        storage.removeItem('persist: root');

        state = undefined;
    }

    return appReducer(state, action);
};